// For consent per cookie category
export enum CookieConsentGroup {
	Functional = 'functional',
	Analytics = 'analytics',
	Tracking = 'tracking'
}
